import BackendDeveloperPage from "./BackendDeveloperPage";

export default function NodeDeveloperPage() {
  return <BackendDeveloperPage technology="nodejs" />;
}
